import { withEnumBadge } from "@/components/EnumBadge.tsx";
import { statusDescriptions } from "@/modules/compute/statusLabels.tsx";
import type { VmStatusEnum } from "@warrenio/api-spec/spec.oats.gen";

export const VmStatusBadge = withEnumBadge<VmStatusEnum>(statusDescriptions);
